export default {
  groupName: 'ford-ca',
  appName: 'Ford Canada',
  isAuto: true,
  image: 'ford.png',
  baseRoute: '/ford-ca',
  description:
  'Ford - Canada Advertising Dashboard (Starting Apr 2019)'
}
